import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const pillBase = "omponents__Pill__Pill_styles_ts-pillBase-p5rjc7o";
export const pillActive = `${"omponents__Pill__Pill_styles_ts-pillActive-p1ywuoes"} ${pillBase}`;
export const pillSecondaryBase = "omponents__Pill__Pill_styles_ts-pillSecondaryBase-p3cqn26";
export const pillLightBlueBase = "omponents__Pill__Pill_styles_ts-pillLightBlueBase-p1uvvc6p";

require("./Pill_styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Pill_styles.ts");